import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { PerfilStatus } from '../types/perfil';

type Props = {
  tipo: 'tenant' | 'fornecedor';
};

const AlertaPerfilIncompleto: React.FC<Props> = ({ tipo }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<PerfilStatus | null>(null);

  useEffect(() => {
    const endpoint = tipo === 'tenant' ? '/tenant/perfil/status' : '/fornecedores/perfil/status';
    let ativo = true;

    const carregar = () => {
      api.get(endpoint)
        .then((resposta) => {
          if (ativo) setStatus(resposta.data);
        })
        .catch(() => {
          if (ativo) setStatus(null);
        });
    };

    carregar();
    window.addEventListener('perfil-operacional-atualizado', carregar);

    return () => {
      ativo = false;
      window.removeEventListener('perfil-operacional-atualizado', carregar);
    };
  }, [tipo]);

  if (!status || status.completo) return null;

  return (
    <div className="alerta alerta-aviso perfil-alerta" role="status">
      <div className="perfil-alerta-conteudo">
        <span><AlertTriangle size={18} aria-hidden="true" /> ⚠️ Perfil da empresa</span>
        <strong>{status.percentual}% completo</strong>
        <div className="perfil-progress-track" aria-hidden="true">
          <div style={{ width: `${status.percentual}%` }} />
        </div>
        <small>Faltam: {status.campos_em_falta.length > 0 ? status.campos_em_falta.join(', ') : 'nenhum campo obrigatório'}.</small>
        <ul className="perfil-checklist">
          {status.campos.map((campo) => (
            <li key={campo.chave} className={campo.preenchido ? 'preenchido' : ''}>
              {campo.preenchido ? '✔' : '□'} {campo.label}
            </li>
          ))}
        </ul>
      </div>
      <button className="botao botao-primario" type="button" onClick={() => navigate(tipo === 'tenant' ? '/configuracoes-empresa' : '/fornecedor/perfil')}>
        Completar perfil
      </button>
    </div>
  );
};

export default AlertaPerfilIncompleto;
